import { Map } from 'leaflet';
import React, { createContext, ReactNode, useState } from 'react';

type MapContainerRefContextType = {
  map: Map | undefined;
  setMap: (arg: Map) => void;
};
export const MapContainerRefContext = createContext({} as MapContainerRefContextType);

type MapContainerRefProviderProps = { children: ReactNode };

// simple context to store and provide MapContainer ref from leaflet, so leaflet methods can be used and accessed outside of MapContainer component
const MapContainerRefProvider = ({ children }: MapContainerRefProviderProps) => {
  // passed to components outside of mapContainer so they can access leaflet methods
  const [map, setMap] = useState<Map | undefined>(undefined);

  const value: MapContainerRefContextType = { map: map, setMap: setMap };

  return (
    <MapContainerRefContext.Provider value={value}>{children}</MapContainerRefContext.Provider>
  );
};

export default MapContainerRefProvider;
